import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import "./text-elements.css";

interface Props {
  title: string;
  value: string;
  variant?: "outline" | "contained";
  noSign?: boolean;
  valueColor?: string;
}

export const BalanceValueCard = ({
  title,
  value,
  variant = "outline",
  noSign,
  valueColor,
}: Props) => {
  return (
    <Flex
      padding="12px"
      gap="10px"
      borderRadius="12px"
      border={
        variant === "outline"
          ? `1px solid ${AppColors.WHITE_BORDER_1}`
          : "1px solid transparent"
      }
      bgColor={variant === "contained" ? "black" : "transparent"}
      flexDir="column"
    >
      <Text
        className="abdc-card-title"
        color={variant === "contained" ? "white" : AppColors.GRAY_TEXT}
      >
        {title}
      </Text>
      <Text
        data-testid="account-balance-value"
        className="abdc-card-value"
        color={valueColor ?? (variant === "contained" ? "white" : "")}
      >
        {!noSign && "$"}&nbsp;{value}
      </Text>
    </Flex>
  );
};
